module.exports = __webpack_public_path__ + "static/editor-with-console-460e559d2ac604d840b3525f8704170f.jpg";